import {
    NinchatState,
    NinchatStore,
} from 'api/types'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatChannelFoundEvent} from '../types/events'
import {extractProperties} from '.'

export const channelFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        channel_members,
        ...properties
    } = extractProperties<NinchatChannelFoundEvent>(action.payload)

    // if its not my channel do nothing
    if (!state.user_channels[channel_id]) {
        return
    }

    const _channel_members: NinchatStore.NinchatChannelMembersStore = {}

    for (const user_id of Object.keys(channel_members ?? {})) {
        const {
            user_attrs,
            ...channel_member
        } = channel_members?.[user_id] ?? {}

        if (user_id === state.user_id) {
            state.user_attrs = user_attrs ?? {}
        } else {
            state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser
            state._users[user_id].user_attrs = user_attrs ?? {}
        }

        _channel_members[user_id] = channel_member
    }

    const {
        channel_status,
        seen_message_id,
    } = state.user_channels[channel_id] ?? {}

    const keepStore = properties.seen_message_id ? seen_message_id ? properties.seen_message_id < seen_message_id : false : true

    state.user_channels[channel_id] = {
        ...properties,
        channel_members: _channel_members,
        ...keepStore && {
            channel_status,
            seen_message_id,
        },
    }
}
